export const BACKEND_URL = process.env.REACT_APP_BACKENDURL || 'https://chat.nexuslinkdev.com:3027/api/chat';
// export const BACKEND_URL = process.env.REACT_APP_BACKENDURL || 'http://localhost:8000/api/chat';